import * as React from 'react';
import {
  withStyles,
  WithStyles,
} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import CordovaContext from '../../../cordovaContext';
import {
  BoxedRow,
  CustomDialogContent,
  Row,
  dialogStyles,
} from '../DialogComponens';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof dialogStyles>{
  text: JSX.Element;
  next: () => void;
}

class StepInfo extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);    
  }

  public render() {
    const { text, next } = this.props;

    return (<>
        <CustomDialogContent >
          <BoxedRow style={{fontWeight: 500, fontSize: '17px'}}>
            {text}
          </BoxedRow>
        </CustomDialogContent>
        <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
          <Button onClick={() => next()} color='primary' variant='contained' size="large">
            {tn.lang.okay}
          </Button>
        </Row></>
    );
  }
}


StepInfo.contextType = CordovaContext;

export default withStyles(dialogStyles)(StepInfo);



// WEBPACK FOOTER //
// ./src/components/economy/setup/StepInfo.tsx